<template>
  <div>
    <custom-actions :panel="!orderId" :show-back="!!orderId">
      <template #header>
        <el-button v-if="hasDateSetting" type="primary" @click="showDateSetting">提货日期配置</el-button>
        <el-button v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
      </template>
      <el-form v-if="!orderId" :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="客户名称" prop="userName">
          <!-- <el-select
            clearable
            filterable
            v-model="searchForm.userId"
            placeholder="请选择客户名称"
          >
            <el-option
              v-for="(item, index) of userList"
              :value="item.userId"
              :label="item.userName"
              :key="index"
            ></el-option>
          </el-select> -->
          <el-input clearable v-model="searchForm.userName" placeholder="请输入客户名称" />
        </el-form-item>
        <el-form-item label="提货编号" prop="pickupNumber">
          <el-input clearable v-model="searchForm.pickupNumber" placeholder="请输入提货编号" />
        </el-form-item>
        <el-form-item label="仓库名称" prop="warehouseId">
          <el-select clearable filterable v-model="searchForm.warehouseId" placeholder="请选择仓库名称">
            <el-option v-for="(item, index) of warehouseList" :value="item.warehouseId" :label="item.warehouseName" :key="index"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="商品名称" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="请输入商品名称" />
        </el-form-item> -->

        <el-form-item label="关联状态" prop="ycState">
          <el-select clearable filterable v-model="searchForm.ycState" placeholder="请选择关联状态">
            <el-option value="2" label="已关联"></el-option>
            <el-option value="1" label="未关联"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提货日期" prop="dateArr">
          <el-date-picker v-model="dateArr" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="140" label="提货编号" prop="pickupNumber"></el-table-column>
        <el-table-column min-width="120" label="订单编号" prop="orderNumber"></el-table-column>
        <el-table-column min-width="200" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="提货库点"
          prop="vehicleStartAddressName"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="提货日期"
          prop="vehicleDateStart"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="保证金抵用" prop="isDepositAmount">
          <template v-slot="{ row }">
            {{ row.isDepositAmount === '1' ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="保证金类型" prop="orderDepositType">
          <template v-slot="{ row }">
            {{ orderDepositTypeMap.get(row.orderDepositType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="保证金比例" prop="orderDeposit">
          <template v-slot="{ row }">
            {{ row.orderDeposit }}{{ row.orderDepositType && row.orderDepositType === '2' ? (row.specUnit ? '/' + row.specUnit : '') : '%' }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="计划数量" prop="planQuantity">
          <template v-slot="{ row }">
            {{ (row.planQuantity || 0) + row.specUnit }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="发货数量" prop="pickupQuantity">
          <template v-slot="{ row }">
            {{ (row.pickupQuantity || 0) + row.specUnit }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="到货数量" prop="arrivalQuantity">
          <template v-slot="{ row }">
            {{ (row.arrivalQuantity || 0) + row.specUnit }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="提货单价(元)" prop="pickupPrice"></el-table-column>
        <el-table-column min-width="120" label="销售单价(元)" prop="specPrice"></el-table-column>
        <el-table-column min-width="120" label="销售总价(元)" prop="specAllPrice"></el-table-column>
        <el-table-column min-width="160" label="其他费用(运费等)" prop="otherFees">
          <template v-slot="{ row }">
            {{ row.otherFees }}<span v-if="row.remark">({{ row.remark }})</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="释放保证金" prop="releasedDeposit"></el-table-column>
<!--        <el-table-column min-width="120" label="云采关联" prop="ycState">-->
<!--          <template v-slot="{ row }">-->
<!--            <el-tag type="danger" v-if="row.ycState === '1'">未关联</el-tag>-->
<!--            <el-tag type="success" v-else>已关联</el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column min-width="120" label="提货状态" prop="pickupStatus">
          <template v-slot="{ row }">
            <!-- <el-tag v-if="row.pickupStatus == '1'">业务员审核</el-tag>
            <el-tag v-if="row.pickupStatus == '2'">业务经理审核</el-tag>
            <el-tag type="success" v-if="row.pickupStatus == '3'">已完成</el-tag>
            <el-tag type="danger" v-if="row.pickupStatus == '4'">流程驳回</el-tag>
            <el-tag type="warning" v-if="row.pickupStatus == '5'">车辆装运中</el-tag>
            <template v-if="row.pickupStatus == '5'">
              <el-tag v-if="row.isVehicle === '2'" type="warning">采购确认中</el-tag>
              <el-tag v-else type="warning">车辆装运中({{ reservationStatusMap.get(row.reservationStatus) }})</el-tag>
            </template> -->

            <el-tag v-if="row.pickupStatus == '3'" type="success">已发货</el-tag>
            <el-tag v-else type="warning">未发货</el-tag>

          </template>
        </el-table-column>
        <!-- <el-table-column min-width="140" label="创建时间" prop="ctime"></el-table-column> -->

        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/deliveryOrder/detail?pickupId=' + row.pickupId + '&relation=1')">详情</el-button>
            <el-button v-if="hasExport" type="text" @click="exportYxcXzFhd(row.pickupId)">导出发货单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { pickupStatus, reservationStatus, orderDepositType } from '@/utils/dict'
import { deepClone } from '@/utils/utils'
export default {
  name: 'deliveryOrder',
  mixins: [keepAlive],
  data() {
    return {
      showSettingVisible: false,
      reservationStatusMap: reservationStatus,
      orderDepositTypeMap: orderDepositType,
      tableData: [],
      pickupStatusMap: pickupStatus,
      page: 1,
      total: 0,
      loading: false,
      settingList: [],
      dateSettingForm: {
        warehouseType: '1', // 仓库性质1内库2外库
        wkDate: [], // 允许提货日期(周)多个用,隔开
        isBulkOil: '1' // 是否散油，0表示不是，1表示是
      },
      settingRules: {
        warehouseType: [{ required: true, message: '请选择仓库性质' }],
        wkDate: [{ required: true, message: '请选择提货日期' }],
        isBulkOil: [{ required: true, message: '请选择是否散油' }]
      },
      searchForm: {
        userId: '',
        userName: '',
        ycState: '',
        pickupNumber: '',
        pickupStatus: '5',
        specName: '',
        warehouseId: ''
      },
      dateArr: [],
      userList: [],
      showDlg: false,
      rowId: '',
      showEditDlg: false,
      warehouseList: []
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    userInfo() {
      return this.$store.state.user
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasCompleteEdit() {
      return this.buttonList.includes('completeedit')
    },
    hasDateSetting() {
      return this.buttonList.includes('dateSetting')
    },
    hasApproval2() {
      return this.buttonList.includes('cwapproval') && this.userInfo.isLeader === '1'
    },
    hasApproval1() {
      return this.buttonList.includes('approval')
    },
    // hasExport() {
    //   return this.buttonList.includes('export')
    // },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    orderId() {
      return this.$route.query.orderId
    },
    hasExport() {
      const buttonList = this.$store.getters.getMenuByCode('YCCXGL')
      return buttonList.includes('export')
    }
  },
  created() {
    this.loadUser()
    this.loadData()
    this.loadWarehouseList()
  },
  methods: {
    loadWarehouseList() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.warehouseList = res.list || []
      })
    },
    showDateSetting() {
      this.showSettingVisible = true
      this.$axios.get(this.$apis.deliveryOrder.selectLyWarConfByList).then(res => {
        res.list.forEach(item => {
          item.wkDate = item.wkDate ? item.wkDate.split(',') : []
        })
        this.settingList = res.list || []
        this.setSettingForm(this.dateSettingForm.warehouseType, this.dateSettingForm.isBulkOil)
      })
    },
    setSettingForm(warehouseType, isBulkOil) {
      console.log('warehouseType', warehouseType)
      console.log('isBulkOil', isBulkOil)
      const formData = this.settingList.find(item => item.warehouseType === warehouseType && item.isBulkOil === isBulkOil)
      this.dateSettingForm = deepClone(formData)
    },
    saveSetting() {
      this.$refs.dateSettingForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.deliveryOrder.updateLyWarConf, {
            warehouseType: this.dateSettingForm.warehouseType,
            wkDate: this.dateSettingForm.wkDate.join(','),
            isBulkOil: this.dateSettingForm.isBulkOil
          }).then(() => {
            this.showDateSetting()
          })
        }
      })
    },

    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      let startDate = null
      let endDate = null
      if (this.dateArr && this.dateArr.length > 0) {
        startDate = this.dateArr[0]
        endDate = this.dateArr[1]
      }
      this.$axios.post(this.$apis.deliveryOrder.exportYxPickupOrder, {
        ...this.searchForm,
        startDate,
        endDate
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    exportYxcXzFhd(pickupId) {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.deliveryOrder.exportXzFhd, {
        pickupId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']

          let fileName = '发货单.pdf'

          if (contentDisposition) {
            // 匹配 filename="xxx.pdf"
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
            }
          }
          // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          console.log('fileName', fileName)
          this.downloadFile2(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile2(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    onEdit(row) {
      this.rowId = row.pickupId
      this.showEditDlg = true
    },
    onDown(url) {
      window.open(url, '_blank')
    },
    onAppoval(row) {
      this.currentPickupStatus = row.pickupStatus
      this.rowId = row.pickupId
      this.showDlg = true
    },
    loadUser() {
      this.$axios
        .get(this.$apis.system.selectSysUserByPage, { userType: '3' })
        .then(res => {
          this.userList = res.list || []
        })
    },

    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm,
        isVehicle: '2',
        orderId: this.orderId || undefined
      }
      console.log('params', params)
      if (this.dateArr && this.dateArr.length > 0) {
        params.startDate = this.dateArr[0]
        params.endDate = this.dateArr[1]
      } else {
        params.startDate = undefined
        params.endDate = undefined
      }

      this.$axios
        // .get(this.$apis.yxcDeliveryOrder.selectYxcPickupOrderByPage, {
        .get(this.$apis.deliveryOrder.selectYxPickupOrderByPageV2, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.dateArr = []
      this.$refs.formData.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="scss"></style>
